module.exports = __webpack_public_path__ + "img/0Q3A3733_L_WoodMatted.6a64a529.jpg";